import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const attributesGridColumns = () => [
    {
        field: 'value',
        headerName: 'Value',
        hide: false,
        wrapText: true,
        autoHeight: true,
    },
    {
        field: 'tasks',
        headerName:  apiProvider.getEntityUpper() + 's',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        width: 120,
        hide: false,
        sort: "desc",
        wrapText: true,
        autoHeight: true,
    },
    {
        field: 'events',
        headerName: 'Events',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        width: 100,
        hide: false,
        wrapText: true,
        autoHeight: true,
    },
    {
        field: 'perc_total_tasks',
        headerName: '% ' + apiProvider.getEntityUpper() + 's',
        width: 115,
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1 }),
        hide: false,
        wrapText: true,
        autoHeight: true,
    },
    {
        field: 'perc_total_events',
        headerName: '% Total Events',
        width: 115,
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration (' + apiProvider.getEntityUpper() + ')',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        width: 140,
        hide: false,
        wrapText: true,
        autoHeight: true,
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation (' + apiProvider.getEntityUpper() + ')',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        width: 115,
        hide: true,
        wrapText: true,
        autoHeight: true,
    },

];
